import emptySVG from '../backgrounds/filemissing.svg';

export function FileNotFound() {
    return (
        <div className="position-relative svgBG mt-5" style={{ right: 'auto', left: 'auto', height: '500px', backgroundSize: 'auto', backgroundPosition: 'top center', backgroundImage: `url(${emptySVG})`, backgroundRepeat: 'no-repeat' }}>
            <div className="px-3 py-3 rounded-2 glass position-relative shadow-sm text-center" style={{ right: 'auto', left: 'auto', top: '20vh', width: '100%', marginRight: 'auto', marginLeft: 'auto', backgroundColor: 'rgba(255, 255, 255, 0.35' }}>
                <h3>File not found</h3>
            </div>
        </div>
    );
}
